import React from 'react';
import { Link } from 'react-router';
import { Sparkles, Radio, Home, ExternalLink } from 'lucide-react';
import { BrandLogo } from '../components/BrandLogo';
import { lscPath } from '../lsc/routing';
import { resolveEngineWaitlistHref } from '../utils/engineAccess';

const PrivateBetaPage: React.FC = () => {
  const waitlistHref = resolveEngineWaitlistHref();
  const isExternalWaitlist = waitlistHref.startsWith('http') || waitlistHref.startsWith('mailto:');

  return (
    <div
      className="max-w-2xl mx-auto text-center py-10 md:py-16"
      data-testid="private-beta-page"
    >
      <div className="flex justify-center mb-6">
        <BrandLogo variant="icon" className="h-16 w-16 rounded-2xl" />
      </div>

      <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-primary-100 text-primary-700 dark:bg-primary-400/20 dark:text-primary-200 text-sm font-medium mb-6">
        <Sparkles className="h-4 w-4" />
        <span>Film Intelligence · Private Beta</span>
      </div>

      <h1
        className="text-3xl md:text-4xl font-bold mb-4"
        style={{ color: '#A259FF', textShadow: '0 0 8px rgba(162, 89, 255, 0.35)' }}
      >
        Scoutlytics Film Intelligence
      </h1>

      <p className="text-lg text-secondary-600 dark:text-secondary-300 mb-3 leading-relaxed">
        Scoutlytics Film Intelligence is currently in private beta.
      </p>
      <p className="text-secondary-600 dark:text-secondary-300 mb-8 leading-relaxed">
        League Stream Center is launching first while Film Intelligence continues R&amp;D with
        verified gameplay samples.
      </p>
      <p className="text-secondary-500 dark:text-secondary-400 mb-10">
        Want early access? Join the waitlist or contact us.
      </p>

      <div className="flex flex-col sm:flex-row gap-3 justify-center items-stretch sm:items-center">
        <Link
          to={lscPath()}
          className="btn-primary inline-flex items-center justify-center gap-2"
          data-testid="private-beta-lsc-cta"
        >
          <Radio className="h-5 w-5" />
          <span>Go to League Stream Center</span>
        </Link>

        {isExternalWaitlist ? (
          <a
            href={waitlistHref}
            className="btn-secondary inline-flex items-center justify-center gap-2"
            data-testid="private-beta-waitlist-cta"
            rel={waitlistHref.startsWith('http') ? 'noopener noreferrer' : undefined}
            target={waitlistHref.startsWith('http') ? '_blank' : undefined}
          >
            <ExternalLink className="h-5 w-5" />
            <span>Join Waitlist</span>
          </a>
        ) : (
          <Link
            to={waitlistHref}
            className="btn-secondary inline-flex items-center justify-center gap-2"
            data-testid="private-beta-waitlist-cta"
          >
            <ExternalLink className="h-5 w-5" />
            <span>Join Waitlist</span>
          </Link>
        )}

        <Link
          to="/"
          className="inline-flex items-center justify-center gap-2 px-4 py-2 rounded-lg text-secondary-600 hover:text-secondary-900 hover:bg-secondary-100 dark:text-secondary-300 dark:hover:text-white dark:hover:bg-secondary-800 transition-colors"
          data-testid="private-beta-home-cta"
        >
          <Home className="h-5 w-5" />
          <span>Return Home</span>
        </Link>
      </div>
    </div>
  );
};

export default PrivateBetaPage;
